import React, { Component } from 'react';
import '../../../src/styles/ShoppingCart.css';
import '../../../src/styles/open-iconic.css';
import '../../../src/styles/open-iconic-bootstrap.css';
import DocumentMeta from 'react-document-meta';
let useragent = navigator.userAgent;
export class LoginShoppingCart extends Component {
    displayName = LoginShoppingCart.name
    constructor(props) {
        super(props)

        this.state = {
            email: '',
            valid: true,
            user: {
                firstName: '',
                lastName: '',
                country: '',
                emailAddress: '',
                password: '',
                phoneNumber: ''
            },
        }
        this.handleEmailChange = this.handleEmailChange.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleChange(event) {
        const { name, value } = event.target;
        const { user } = this.state;
        this.setState({
            user: {
                ...user,
                [name]: value
            }
        });
    }


    handleSubmit(event) {
        event.preventDefault();
       // if (sessionStorage.getItem('user') !== null) {
            //window['NTPT_PGEXTRA'] = 'firstname=' + this.state.user.firstName + '&lastname=' + this.state.user.lastName + '&country=' + this.state.user.country + '&emailaddress=' + this.state.email + '&platform=klo &useragent=' + useragent;
            //const script = document.createElement("script");
            //script.src = "/siqpagetag.js";
            //script.async = true;
            //document.body.appendChild(script);
        //}

        //ntptEventTag('firstname=' + this.state.user.firstName + '&lastname=' + this.state.user.lastName + '&country=' + this.state.user.country + '&emailaddress=' + this.state.user.emailaddress + '&password=' + this.state.user.password + '');
        const { user } = this.state;
       // console.log(window['NTPT_PGEXTRA']);
    }

    validateEmail(email) {
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return re.test(email)
    }

    handleEmailChange(e) {
        const email = e.target.value
        const emailValid = this.validateEmail(email)
        const { user } = this.state;
        this.setState({
            email: e.target.value,
            valid: emailValid
        })
    }

    render() {
        let fieldContainerClass = 'field-container'
        const { email, valid } = this.state

        if (!valid) {
            fieldContainerClass += ' error'
        }
        const meta = {
            title: "Kluwer Law Online - Login",
            canonical: window.location.href,
        }

        return (
            <DocumentMeta {...meta}>
            <div className="col-12 klo-shopping-cart">
                <div className="row">
                    <div className="col-lg-12 colPadding margintop">
                        <div id="yourDetails" className="mt-3" >
                            <p className="franziskafont">Login to shopping cart to continue</p>
                            <div className="col-sm-12 row">
                                <div className="col">
                                    <div className="row">
                                        <form style={{ width: '55%' }}>
                                            <h4 className="my-3 green-heading" style={{ fontSize: '17px' }}>Login</h4>
                                            <div className="form-group mt-3 col-8 col-sm-12 px-0">
                                                <div className={fieldContainerClass}>
                                                    <label for="Email">Email address</label>
                                                    <input type='email' value={this.state.email} onChange={this.handleEmailChange} className="form-control form-control-sm rounded-0"
                                                        placeholder="Enter your email address" id="Email" />
                                                    <span>Invalid email address!</span>
                                                </div>
                                            </div>
                                            <div className="form-group mt-3 col-8 col-sm-12 px-0">
                                                <label for="password">Password</label>
                                                <input type="password" className="form-control form-control-sm rounded-0" placeholder="Password" id="password" />
                                                <a href="/ForgotPassword" className="Linkclass">Forgot password? </a>
                                            </div>
                                        </form>
                                    </div>
                                    <div className="row">
                                        <button type="button" className="btn next rounded-0">Login to proceed</button>
                                    </div>
                                </div>

                                <div className="col-0 border-right"> </div>
                                <div className="col ml-3">
                                    <div className="col">
                                        <form>
                                            <h5 className="my-3 green-heading" style={{ fontSize: '17px' }}> Not purchased from us before? Create a free account in seconds</h5>

                                            <div className="form-row mt-3">
                                                <div className="col">
                                                    <label for="firstName">First name</label>
                                                    <input type="text" className="form-control form-control-sm rounded-0" name="firstName" id="firstName" placeholder="First name" value={this.state.user.firstName} onChange={this.handleChange} />
                                                </div>
                                                <div className="col">
                                                    <label for="lastName">Last name</label>
                                                    <input type="text" className="form-control form-control-sm rounded-0" id="lastName" name="lastName" value={this.state.user.lastName} onChange={this.handleChange} placeholder="Last name" />
                                                </div>
                                            </div><br></br>
                                            <div className="form-group mt-3">
                                                <label for="country">Country of residence</label>
                                                <select className="form-control form-control-sm rounded-0" id="country" name="country" value={this.state.user.country}
                                                    onChange={this.handleChange} >
                                                    <option selected>United Kingdom</option>
                                                    <option>United Kingdom</option>
                                                    <option>United Kingdom</option>
                                                    <option>United Kingdom</option>
                                                    <option>United Kingdom</option>
                                                </select>
                                            </div><br></br>
                                            <div className="form-row mt-3">
                                                <div className="col-6">
                                                    <div className={fieldContainerClass}>
                                                        <label for="Emailid">Email address</label>
                                                        <input type='email' value={this.state.email} onChange={this.handleEmailChange} className="form-control form-control-sm rounded-0"
                                                            placeholder="Enter your email address" id="Emailid" />
                                                        <span style={{}}>Invalid email address!</span>
                                                    </div>
                                                </div>
                                                <div className="col">
                                                    <label for="reEmailAddress">Re-enter email address</label>
                                                    <input type="text" className="form-control form-control-sm rounded-0" placeholder="Re-enter email address" id="reEmailAddress" />
                                                </div>
                                            </div><br></br>
                                            <div className="form-row mt-3">
                                                <div className="col-6">
                                                    <label for="password">Create a password</label>
                                                    <input type="text" className="form-control form-control-sm rounded-0" name="password" value={this.state.user.password} onChange={this.handleChange} placeholder="Create a password" id="password" />
                                                    <p className="float-right">Must be at least 6 characters</p>
                                                </div>
                                                <div className="col">
                                                    <label for="rePassword">Re-enter password</label>
                                                    <input type="text" className="form-control form-control-sm rounded-0" placeholder="Re-enter password" id="rePassword" />

                                                </div>
                                            </div><br></br>
                                            <div className="square">
                                                <input type="checkbox" id="confirmCreateAccount" />
                                                <label for="confirmCreateAccount"></label>
                                                <span className="Searchlabel">Yes, I would like to create an account</span>
                                            </div>
                                        </form>
                                    </div>
                                    <br></br>
                                    <div className="col">
                                        <p>I consent to the collection of my personal information by Wolters Kluwer Legal & Regulatory U.S., operated through CCH Incorporated and its affiliate Kluwer Law International, so that I can create an account to store my contact information and order history to facilitate ecommerce transactions. I understand that my personal information will be processed for this purpose in the United States where CCH Incorporated operates.</p>
                                        <p>You may change or withdraw your consent at any time by contacting our Customer Service team at +1-301-698-7100 or <a href="WKLRUSGDPR@wolterskluwer.com" target="_blank">WKLRUSGDPR@wolterskluwer.com</a>. For more information about our privacy practices, please refer to our privacy statement: <a href="www.WoltersKluwerLR.com/privacy" target="_blank">www.WoltersKluwerLR.com/privacy</a>.</p>
                                    </div>
                                    <br></br>
                                    <div className="col">
                                        <div class="rc-anchor rc-anchor-normal rc-anchor-light">
                                            <div class="rc-anchor-content">
                                                <div class="rc-inline-block">
                                                    <div class="rc-anchor-center-container">
                                                        <div class="rc-anchor-center-item rc-anchor-checkbox-holder"><span class="recaptcha-checkbox goog-inline-block recaptcha-checkbox-unchecked rc-anchor-checkbox recaptcha-checkbox-clearOutline" role="checkbox" aria-checked="false" id="recaptcha-anchor" tabindex="0" dir="ltr" aria-labelledby="recaptcha-anchor-label"><div class="recaptcha-checkbox-border" role="presentation"></div><div class="recaptcha-checkbox-borderAnimation" role="presentation"></div><div class="recaptcha-checkbox-spinner" role="presentation"></div><div class="recaptcha-checkbox-spinnerAnimation" role="presentation"></div><div class="recaptcha-checkbox-checkmark" role="presentation"></div></span></div>
                                                    </div>
                                                </div>
                                                <div class="rc-inline-block">
                                                    <div class="rc-anchor-center-container"><label class="rc-anchor-center-item rc-anchor-checkbox-label" id="recaptcha-anchor-label">I'm not a robot</label></div>
                                                </div>
                                            </div>
                                            <div class="rc-anchor-normal-footer">
                                                <div class="rc-anchor-logo-portrait" role="presentation">
                                                    <div class="rc-anchor-logo-img rc-anchor-logo-img-portrait"></div>
                                                    <div class="rc-anchor-logo-text">reCAPTCHA</div>
                                                </div>
                                                <div class="rc-anchor-pt"><a href="https://www.google.com/intl/en/policies/privacy/" target="_blank">Privacy</a> - <a href="https://www.google.com/intl/en/policies/terms/" target="_blank">Terms</a></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-12 row mb-5 mt-3 ">
                                <div className="col">
                                    <button type="button" className="btn back-btn float-left rounded-0">Back</button>
                                </div>
                                <div className="col colPadding">
                                    <button type="button" className="btn next rounded-0" onClick={this.handleSubmit}>Create account to proceed</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> </div>
                </DocumentMeta>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Shopping Cart/LoginShoppingCart.jsx